import { Input } from "@progress/kendo-react-inputs";

export const HintProperty = {
  propertyName: "Hint",
  propertyDisplay: "Hint",
  propertyType: "string",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
      />
    );
  },
};
